module.exports = __webpack_public_path__ + "static/media/Jon Snow 1.c20289e6.jpg";